import React, {
  Component,
} from 'react';
import Modal from '../Modal';
import Filter from './filter_container';

class FilterModal extends Component {
  render() {
    return (
      <Modal
        paddingTop={0}
        overlayTop={0}
        scrollable
        closeOnOverlayClick={false}
        closeOnOutsideClick={false}
        isOpened
        onClose={this.onCloseRequest}
      >
        <Filter />
      </Modal>
    );
  }
}

export default FilterModal;



// WEBPACK FOOTER //
// ./src/components/AdvancedFilter/FilterModal.jsx